module.exports = __webpack_public_path__ + "static/media/event-volunteers.878ce32b.jpg";